import React from "react";
import { FileText } from "lucide-react";

const FileUpload = ({ msg }) => {
  return (
    <div className="flex items-center gap-2 p-2 bg-gray-100 rounded-lg max-w-[80%]">
      <FileText size={20} />
      <a href={msg.fileURL} target="_blank" rel="noopener noreferrer" className="text-gray-900 no-underline text-sm hover:underline">
        {msg.fileName.length > 15
          ? msg.fileName.substring(0, 12) + "..."
          : msg.fileName}
      </a>
    </div>
  );
};

export default FileUpload;